import { WebsocketProvider } from "@y-rb/actioncable";
import { AwarenessUser, InitialAwarenessUser } from "./types";
import { stringToHslColor } from "./colors";

export class AwarenessControl {
  provider: WebsocketProvider;
  initialAwarenessUser: InitialAwarenessUser;
  awarenessUser: AwarenessUser;
  constructor(
    provider: WebsocketProvider,
    awarenessUser: InitialAwarenessUser
  ) {
    this.provider = provider;
    this.initialAwarenessUser = awarenessUser;
    this.initAwareness()
  }

  initAwareness(): void {
    const localState = this.provider.awareness.getLocalState();
    if (localState.id && localState.color) {
      this.awarenessUser = localState as AwarenessUser;
      return;
    }
    this.awarenessUser = {
      ...this.initialAwarenessUser,
      color: stringToHslColor(this.initialAwarenessUser.name),
    };
    this.provider.awareness.setLocalState(this.awarenessUser);
  }
}
